import { useState, useEffect, useCallback, useRef } from "react";

import { Invoice } from "../bitmaker/schemas/Billing/Invoice";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export const normalizeInvoice = (invoice: any): Invoice => ({
  ...invoice,
  subtotal: Number(invoice.subtotal),
  total_tax: Number(invoice.total_tax),
  total_amount: Number(invoice.total_amount),
  amount_paid: Number(invoice.amount_paid),
});

export const useInvoices = () => {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [fetchInvoicesError, setFetchInvoicesError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchInvoices = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingInvoices(true);
    setFetchInvoicesError(null);

    BitmakerAPIClient.get("/billing/invoices", null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching invoices:", message);
        setFetchInvoicesError("Error fetching invoices. Please try again.");
        setLoadingInvoices(false);
        return;
      }

      const data = Array.isArray(response.data)
        ? (response.data as Invoice[])
        : [];
      setInvoices(data.map(normalizeInvoice));
      setLoadingInvoices(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  return {
    invoices,
    loadingInvoices,
    fetchInvoicesError,
    refetchInvoices: fetchInvoices,
  };
};
